import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class OidcSecurityServiceStrategy {
  abstract userData$: Observable<{ userData?: { sub: string } }>;
  abstract isAuthenticated$: Observable<{ isAuthenticated: boolean }>;
  abstract getAccessToken(): Observable<string>;
  abstract getIdToken(configId?: string | undefined): Observable<string>;
  abstract logoffLocal(configId?: string): void;
}
